import { Outlet, createFileRoute } from '@tanstack/react-router';
import { requireSession } from '@portal/platform/guards';
import { DealerShell } from '@/components/shell';

/** Every logged-in page: the session guard and the shell. */
export const Route = createFileRoute('/_app')({
  beforeLoad: ({ context, location }) => {
    requireSession(context, location);
  },
  component: () => (
    <DealerShell>
      <Outlet />
    </DealerShell>
  ),
});
